import { Server } from '@wajeez/wajeez.microservices';
import dayjs from 'dayjs';

import { FieldContent } from './FieldContent';
import { FieldArrayContent } from './FieldArrayContent';
import { FieldSelectContent } from './FieldSelectContent';

interface TypeFieldOptionsDataComponentsProps {
  fieldType: Server.FieldType | undefined;
  fieldOptions: Server.ComponentTypeFieldOptionsOutput;
}

export const TypeFieldOptionsDataComponents = ({
  fieldType,
  fieldOptions,
}: TypeFieldOptionsDataComponentsProps) => {
  const renderFieldOptionsComponents = () => {
    switch (fieldType) {
      case Server.FieldType.Text:
        return (
          <>
            <FieldContent label="Min Length" value={fieldOptions.minLength} />
            <FieldContent label="Max Length" value={fieldOptions.maxLength} />
          </>
        );
      case Server.FieldType.AreaText:
        return (
          <>
            <FieldContent label="Min Length" value={fieldOptions.minLength} />
            <FieldContent label="Max Length" value={fieldOptions.maxLength} />
            <FieldContent label="Rows" value={fieldOptions.rows} />
          </>
        );
      case Server.FieldType.TineMCE:
        return (
          <>
            <FieldContent label="Min Length" value={fieldOptions.minLength} />
            <FieldContent label="Max Length" value={fieldOptions.maxLength} />
            <FieldContent label="Height" value={fieldOptions.height} />
          </>
        );
      case Server.FieldType.Date:
      case Server.FieldType.DateTime:
        return (
          <>
            <FieldContent
              label="Min Date"
              value={dayjs(fieldOptions.minDate).format('DD/MM/YYYY')}
            />
            <FieldContent
              label="Max Date"
              value={dayjs(fieldOptions.maxDate).format('DD/MM/YYYY')}
            />
          </>
        );
      case Server.FieldType.DragFile:
      case Server.FieldType.UploadFile:
      case Server.FieldType.UploadImage:
        return (
          <>
            <FieldContent label="Size Up To (KB)" value={fieldOptions.upToKB} />
            <FieldContent
              label="Upload Endpoint"
              value={fieldOptions.uploadEndPoint}
            />
            <FieldArrayContent label="Types" value={fieldOptions.types} />
          </>
        );
      case Server.FieldType.CallbackSelect:
        return (
          <>
            <FieldContent
              label="Is Multi?"
              value={fieldOptions.isMulti ? 'Yes' : 'No'}
            />
            <FieldContent
              label="With Order?"
              value={fieldOptions.withOrder ? 'Yes' : 'No'}
            />
            <FieldContent
              label="Options List Endpoint"
              value={fieldOptions.optionsListEndPoint}
            />
          </>
        );
      case Server.FieldType.Select:
        return (
          <>
            <FieldContent
              label="Is Multi?"
              value={fieldOptions.isMulti ? 'Yes' : 'No'}
            />
            <FieldContent
              label="With Order?"
              value={fieldOptions.withOrder ? 'Yes' : 'No'}
            />
            <div className="col-span-2">
              <FieldSelectContent
                label="Select Options"
                value={fieldOptions.selectOptions}
              />
            </div>
          </>
        );
      case Server.FieldType.Number:
        return (
          <>
            <FieldContent label="Min" value={fieldOptions.min} />
            <FieldContent label="Max" value={fieldOptions.max} />
          </>
        );
      case Server.FieldType.RequiredComponent:
        return (
          <div className="col-span-2">
            <FieldContent label="Type" value={fieldOptions.typeId} />
          </div>
        );
      case Server.FieldType.PredefinedComponent:
        return (
          <div className="col-span-2">
            <FieldArrayContent
              label="Allowed Predefined Components"
              value={fieldOptions.allowedPredefinedComponents}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return <>{renderFieldOptionsComponents()}</>;
};
